import {Component, inject} from '@angular/core';
import {CommonModule} from "@angular/common";
import {TableLazyLoadEvent, TableModule} from "primeng/table";
import {CardModule} from "primeng/card";
import {MultiSelectModule} from "primeng/multiselect";
import {FormsModule} from "@angular/forms";
import {ButtonModule} from "primeng/button";
import {MenuModule} from "primeng/menu";
import {RippleModule} from "primeng/ripple";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {ToastModule} from "primeng/toast";
import {EbayService, UtilityService} from "@app/core/services";
import {EbayStockPriceAnalysis} from "@app/core/interfaces/ebay";
import {BaseComponent} from "@app/core/bases";
import {TagModule} from "primeng/tag";
import {RouterLink} from "@angular/router";
import {SelectChangeEvent, SelectModule} from "primeng/select";

interface Column {
    field: string;
    header: string;
}

interface EbayListFilters {
    seuil_pourcentage: number | null;
    direction: string | null;
    condition: string | null;
}

@Component({
  selector: 'app-ebay-list-prix',
    imports: [
        CommonModule,
        TableModule,
        CardModule,
        SelectModule,
        MultiSelectModule,
        FormsModule,
        ButtonModule,
        MenuModule,
        RippleModule,
        ConfirmDialogModule,
        ToastModule,
        TagModule,
        RouterLink,
    ],
  templateUrl: './ebay-list-prix.html'
})
export class EbayListPrix extends BaseComponent {
    ebayService: EbayService = inject(EbayService);
    utilityService: UtilityService = inject(UtilityService);
    ebayStockPrices: EbayStockPriceAnalysis[] = [];
    selectedEbayStockPrice!: EbayStockPriceAnalysis | null;

    resultsLength = 0;
    pageIndex = 0;
    pageSize = 20;
    sort!: { field: string, order: number };
    filters: EbayListFilters = {
        seuil_pourcentage: 10,
        direction: null,
        condition: null,
    };
    cols: Column[] = [
        { field: 'produit_id', header: 'ID Produit' },
        { field: 'etat', header: 'État' },
        { field: 'marque', header: 'Marque' },
        { field: 'reference', header: 'Référence' },
        { field: 'date_analyse', header: "Date d'analyse" },
        { field: 'prix_stock', header: 'Prix stock' },
        { field: 'prix_marche_median', header: 'Prix marché médian' },
        { field: 'ecart_pourcentage', header: "Écart en %" },
    ];
    selectedColumns: Column[] = this.cols;

    isLoadingResults = true;
    isLoadedFromStorage = false;

    directions: any[] = [
        { name: 'Prix stock inférieur au prix marché', code: 'dessous' },
        { name: 'Prix stock supérieur au prix marché', code: 'dessus' },
    ];

    states: any[] = [
        { name: 'Neuf', code: 'NEUF', severity: 'success', value: 'neuf' },
        { name: 'Occasion', code: 'OCCASION', severity: 'warn', value: 'occasion' },
    ];

    seuilsEcart: number[] = [10, 25, 40];

    getTableEntries() {
        this.isLoadingResults = true;

        const formatedFilter: any  = {};
        formatedFilter.seuil_pourcentage = this.filters.seuil_pourcentage;
        if (this.filters.direction) {
            formatedFilter.direction = this.filters.direction;
        }
        if (this.filters.condition) {
            formatedFilter.condition = this.filters.condition;
        }

        this.apiCall$?.unsubscribe();
        this.apiCall$ = this.ebayService.getEbayAnalyseStocksPrice({
            page: this.pageIndex + 1,
            size: this.pageSize,
            order_by: this.sort?.field,
            order: this.sort?.order === 1 ? 'asc' : 'desc',
            ...formatedFilter,
        }).subscribe({
            next: (data) => {
                this.ebayStockPrices = data.results;
                this.resultsLength = data.total;
            },
            error: (err) => {
                this.isLoadingResults = false;
                console.error(err);
            },
            complete: () => {
                this.isLoadingResults = false;
                this.apiCall$?.unsubscribe();
            }
        });
    }

    onLazyLoad(event: TableLazyLoadEvent) {
        this.pageIndex = event.first! / event.rows!;
        this.pageSize = event.rows!;
        this.sort = { field: event.sortField as string, order: event.sortOrder as number };
        this.getTableEntries();
    }

    onStateRestore(state: any) {
        // Called when dt table restores state from storage
        this.isLoadedFromStorage = true;
        try {
            if (state && state.first !== undefined && state.rows) {
                this.pageIndex = state.first / state.rows;
            }
        } catch (e) {
            // ignore, justepour évité des erreurs si le state n'est pas conforme
        }
    }

    onSelectChange(event: SelectChangeEvent) {
        this.getTableEntries();
    }

    onClear() {
        this.filters = {
            seuil_pourcentage: 10,
            direction: null,
            condition: null,
        };
        this.getTableEntries();
    }
}
